import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useAgentRuns = (threadId: string | null, status?: string) => {
  const fetcher = async () => {
    if (!threadId) return [];
    return await AgentService.getAgentRuns(threadId, status);
  };

  const { data, error, isLoading } = useSWR(
    threadId ? ["agent", "agentRuns", threadId, status] : null,
    fetcher,
    {
      ...defaultSWROption,
      revalidateOnMount: true,
      dedupingInterval: 0,
    },
  );

  const agentRuns = data ?? [];

  // 最新のAgentRunを取得
  const latestAgentRun = agentRuns.length > 0 ? agentRuns[0] : null;

  return {
    agentRuns,
    latestAgentRun,
    error,
    isLoading,
  };
};
